import { useMembership } from '@ocx/data-membership';

import { useConfiguration } from '../../../modules/configuration/useConfiguration';
import { useGetNavigationActions } from '../../../hooks/useGetNavigationActions';
import { useRegisterRefetch } from '../context/home-refresh.context';
import { WelcomeSection } from './welcome-section/welcome-section.component';

export const WelcomeSectionController = () => {
  const { membership, loading, refetch } = useMembership();
  const { config } = useConfiguration();
  const { pushToTransactionHistory, pushToPointExpirationPage } = useGetNavigationActions();

  useRegisterRefetch(refetch);

  return (
    <WelcomeSection
      loading={loading}
      points={membership?.points}
      name={membership?.firstName}
      pointsStrategy={config.loyaltyProgram.pointsStrategy}
      pointExpirationEnabled={config.loyaltyProgram.pointExpiration.isFifo}
      handleClickToPointExpirationPage={pushToPointExpirationPage}
      handleClickToTransactionPage={pushToTransactionHistory}
    />
  );
};
